import React from 'react';
import { 
    translate,
    Filter,
    List, 
    Datagrid,
    TextField, 
    TextInput,
    DateInput,
    DateField,
} from 'react-admin';
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';



const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const QuickFilter = translate(
    withStyles(quickFilterStyles)(({ classes, label, translate }) => (
        <Chip className={classes.root} label={translate(label)} />
    ))
);

export const PhlebotoFilter = props => (
    <Filter {...props}>
        <DateInput source="bleed_date" alwaysOn lable='Bleeding Date' locales="en-us"/>
    </Filter>
);

export const PhlebotoList = props => (
    <List 
        {...props}
        filters={<PhlebotoFilter />}
        perPage={20}
        sort={{ field: 'bleed_date', order: 'ASC' }}
        bulkActionButtons ={false}
        >
        <Datagrid >
            <DateField source="bleed_date" label="Bleeding Date" locales="en-us"/>    
            <TextField source="control_num" label="Control#" />
            <TextField source="volume_weight" label="volume/weight" />
            <TextField source="soft_goods" label="SG Defects/Lot# Init"/>
            <TextField source="spike_time" label="Spike Time"  />
            <TextField source="restick" label="Restick"/>
            <TextField source="vol_collected" label="Vol Collected"/>
            <TextField source="comments_donnor" label="Comments"/>
            <TextField source="disconnect" label="Discon Time"/>
            <TextField source="machine_start" label="Machine Start"/>
        </Datagrid>
    </List>
);


export default PhlebotoList
